import React, { useState } from "react"
import PropTypes from "prop-types"
import Typography from "../UI/Typography/Typography"
import * as styles from "./TextContent-tw-styles"
import Select from "../UI/Input/Select"
import { gaFilterClick } from "../../constants/gtm.constants"
import useScreenSize from "../../hooks/useScreenSize"
import SocialLinks from "../SocialLinks/SocialLinks"
import SocialShareButtons from "../SocialLinks/SocialShareButtons"
import Image from "../UI/Image/Image"


const TextContent = props => {
  const {
    title,
    longTitle,
    subtitle,
    shortDescription,
    variant,
    elementId = "",
    badgeHeading,
    badgeContent,
    content,
    jsonEditor,
    socailIconEnable,
    socialLinks,
    cameoImages = {}
  } = props


  const { careers } = jsonEditor || {}
  const [selectedOption, setSelectedOption] = useState()
  const screen = useScreenSize()


  const style = styles[variant] || styles.defaultStyle
  const careerOption = careers?.map(item => {
    return item.heading
  })

  const cameoImagesCollection = screen?.isMobile
  ? [cameoImages?.cameoMediumMobile, cameoImages?.cameoLargeMobile]
  : [cameoImages?.cameoMedium, cameoImages?.cameoLarge]

  return (
    <div className={style?.richTextWrapperForBg} id={elementId}>
      <div className={style?.richTextWrapper}>
        {(title && 
        (variant === 'H2_HEADING_GREEN' || variant === 'H2_HEADING_GREEN_WITH_PADDING' || variant === 'BOLD_H2_HEADING_GREEN' || variant === 'H2_HEADING_GREEN_SMALL_DESC' || variant === 'H2_HEADING_GREEN_AS_TITLE' || variant === 'H2_HEADING_GREEN_WITH_SMALL_SIZE')) ?
          <h2 className={style?.title}>{title}</h2>
        : (variant === 'NEWSPAGE_DETAIL') ? 
          <h1 className={style?.title}>{title}</h1>
        :
          <Typography
            content={title}
            allow_br_tag={true}
            className={style?.title}
          />
        }
        {longTitle && <div className={style?.title}>{longTitle}</div>}
        {subtitle && <div className={style?.subtitle}>{subtitle}</div>}
        {shortDescription && (
          <Typography
            content={shortDescription}
            allow_br_tag={true}
            data-testid="typography_shortDescription"
            className={style?.shortDescription}
          />
        )}
        {content && (
          <Typography
            content={content}
            allow_br_tag={true}
            data-testid="typography_content"
            className={style?.contentDescription}
          />
        )}
        {(cameoImages && screen?.isMobile && cameoImages?.cameoMediumMobile) ? <div className={style?.imageWrapperMedium}>
              <Image src={cameoImages?.cameoMediumMobile?.url} /> </div> : <div className={style?.imageWrapperMedium}>
              <Image src={cameoImages?.cameoMedium?.url} />
            </div>
        }{(cameoImages && screen?.isMobile && cameoImages?.cameoLargeMobile) ? <div className={style?.imageWrapperLarge}>
        <Image src={cameoImages?.cameoLargeMobile?.url} /> </div> : <div className={style?.imageWrapperLarge}>
        <Image src={cameoImages?.cameoLarge?.url} />
          </div>
        }
        {badgeHeading && (
          <div className="badge">
            <h3>{badgeHeading}</h3>
            <p className={style?.description}>{badgeContent}</p>
          </div>
        )}

        {careerOption && (
          <div className={style?.selectWrapper}>
            <Select
              options={careerOption}
              variant={variant}
              onChange={e => setSelectedOption(e.target.value)}
              gaEventClass={gaFilterClick}
              ariaLabel="Country"
            />{" "}
          </div>
        )}
        {careers &&
          careers?.map(
            (datas, i) =>
              datas?.heading == selectedOption && (
                <div
                  id={datas?.id}
                  key={i}
                  className="richTextWrapper selectDropdownText"
                >
                  <Typography
                    data-testid="typography_selectDropdownText"
                    content={datas?.description}
                    allow_br_tag={true}
                  />
                </div>
              )
          )}

      {socailIconEnable &&
          <div className={style?.socialIcon}>
             {(screen?.isDesktop || screen?.isTablet) && (
              <div id="social-share">
                {socailIconEnable ? (
                  <SocialShareButtons />
                ) : (
                  socialLinks && (
                    <SocialLinks {...socialLinks} variant={variant}  />
                  )
                )}
              </div>
            )}
          </div>
      }
      </div>
    </div>
  )
}

TextContent.propTypes = {
  title: PropTypes.string,
  longTitle: PropTypes.string,
  subtitle: PropTypes.string,
  shortDescription: PropTypes.string,
  content: PropTypes.string,
  variant: PropTypes.string,
  badgeHeading: PropTypes.string,
  badgeContent: PropTypes.string,
  jsonEditor: PropTypes.object,
  elementId: PropTypes.string,
  socialLinks: PropTypes.object,
  socailIconEnable: PropTypes.bool,
  internalTitle: PropTypes.string,
  cameoImages : PropTypes.any
}

export default TextContent